import React, { useMemo } from 'react';
import useAlarmsByGroup from '../../../../../redux/alarm/hooks/useAlarmsByGroup';
import { ComposableDevicesStoreInfoResponse } from '../../../../../service/store/hooks/useDevicesWithComposableDevice';
import { ComposableDevicesManagerStoreInfoResponse } from '../../../../../service/device/hooks/useDevicesManager';
interface AlarmsDeviceProps {
  device:
    | ComposableDevicesStoreInfoResponse
    | ComposableDevicesManagerStoreInfoResponse;
}
export const AlarmsDevice = ({ device }: AlarmsDeviceProps) => {
  const alarms = useAlarmsByGroup({ groupId: device.storeId ?? '' });
  const alarmsByZone = useMemo(() => {
    const controlUnits = Object.values(device.composableZoneMapping ?? {});
    const cu = device.shelfMappings
      .filter((shelfMapping) =>
        controlUnits.includes(shelfMapping?.cuaddr ?? '')
      )
      .map((shelfMapping) => shelfMapping?.cuid);
    return alarms.data?.filter((alarm) => cu.includes(alarm.cu));
  }, [device.composableZoneMapping, device.shelfMappings, alarms.data]);

  return <>{alarmsByZone.length}</>;
};
